import React from 'react';
import Icon from 'screens/shared/icon';

export default ({ type, className = '' }) => {
  const [icon, color, label] = type === 'ACCEPTED'
    ? ['check-circle', 'var(--color-success)', 'Accepted']
    : ['times-circle', 'var(--color-danger)', 'Rejected'];

  return (
    <span className={className}>
      <Icon name={icon} style={{ color, fontSize: 15 }} />
      {' '}
      {label}
    </span>
  );
};
